import { useFormikContext, connect } from 'formik'
import { sortBy } from 'lodash'
import { useEffect } from 'react'
import { mapKeysRecursively } from 'utils/validation'

// Checkout shipping methods start with number so we need to use bracket notation
const dotToBracketNotation = (str: string) =>
  str
    .split('.')
    .map((part, index) => (index ? `['${part}']` : part))
    .join('')

export const ErrorFocus = connect(() => {
  const { errors, isSubmitting, isValidating, values } = useFormikContext()

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const sortedValueNames = mapKeysRecursively(values)
      const inputNames = sortBy(mapKeysRecursively(errors), (item) =>
        sortedValueNames.indexOf(item)
      )
      if (inputNames.length > 0) {
        const firstInput =
          document.querySelector(`[name="${inputNames[0]}"]`) ||
          document.querySelector(
            `[name="${dotToBracketNotation(inputNames[0])}"]`
          )
        if (firstInput) {
          firstInput.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        }
      }
    }
  }, [errors, isSubmitting, isValidating, values])

  return null
})
